// Reserve room for the existing consent banner without changing consent behaviour.
let banner;
let frame;
const root = document.documentElement;
const update = () => {
  frame = undefined;
  const rect = banner?.getBoundingClientRect();
  const style = banner && getComputedStyle(banner);
  const visible = rect && rect.height > 0 && rect.top < innerHeight && rect.bottom > 0 && style.display !== 'none' && style.visibility !== 'hidden' && !banner.hidden && banner.getAttribute('aria-hidden') !== 'true';
  const clearance = visible ? Math.max(0, innerHeight - rect.top) + 12 : 0;
  const value = `${Math.ceil(clearance)}px`;
  if (root.style.getPropertyValue('--cm-consent-clearance') !== value) {
    root.style.setProperty('--cm-consent-clearance', value);
  }
};
const schedule = () => { if (frame === undefined) frame = requestAnimationFrame(update); };
const sizeObserver = new ResizeObserver(schedule);
const stateObserver = new MutationObserver(schedule);
const findBanner = () => {
  const next = document.getElementById('shopify-pc__banner');
  if (next === banner) return;
  sizeObserver.disconnect();
  stateObserver.disconnect();
  banner = next;
  if (banner) {
    sizeObserver.observe(banner);
    stateObserver.observe(banner, { attributes: true, attributeFilter: ['style', 'class', 'hidden', 'aria-hidden'] });
  }
  schedule();
};
new MutationObserver(findBanner).observe(document.body, { childList: true, subtree: true });
addEventListener('resize', schedule, { passive: true });
window.visualViewport?.addEventListener('resize', schedule, { passive: true });
findBanner();

const updatePersonalisationFocus = () => {
  root.removeAttribute('data-cm-personalisation-focus');
  if (document.activeElement?.closest('cm-personalisation')) root.setAttribute('data-cm-personalisation-focus', 'true');
};
document.addEventListener('focusin', updatePersonalisationFocus);
document.addEventListener('focusout', () => queueMicrotask(updatePersonalisationFocus));

// Keep Dondy's launcher above the mobile purchase bar, including wrapped variants.
const stickyBar = document.querySelector('sticky-add-to-cart [ref="stickyBar"]');
if (stickyBar) {
  const reserveStickySpace = () => {
    root.style.setProperty('--cm-sticky-clearance', `${Math.ceil(stickyBar.getBoundingClientRect().height) + 12}px`);
  };
  new ResizeObserver(reserveStickySpace).observe(stickyBar);
  reserveStickySpace();
}
